import { SET_CUSTOM_FIELD_9 } from 'actions';

export function setCustomField9(sourceType: string) {
  return { sourceType, type: SET_CUSTOM_FIELD_9 };
}
